import React from "react";

import { cn } from "@/src/lib/utils";

import type { JSX } from "react";

import type { StatusTone } from "./dataTable.types";

const TONE_CLASSES: Record<StatusTone, string> = {
  success: "bg-status-active",
  warning: "bg-status-warning",
  neutral: "bg-status-neutral",
  error: "bg-status-error",
  info: "bg-status-info",
};

interface DataTableStatusDotProps {
  tone: StatusTone;
  className?: string;
}

function DataTableStatusDot({
  tone,
  className,
}: DataTableStatusDotProps): JSX.Element {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-block size-3 shrink-0 rounded-full",
        TONE_CLASSES[tone],
        className,
      )}
    />
  );
}

export default DataTableStatusDot;
